import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'

export default {
	name: 'lpnmaster',
	components: {
		Pagination,
		Paginate,
		DatePicker,
		Loader
	},
	data: function() {
		return {
			// totalRows:0,
			// currentPage: 0,
			// currentPage2: 0,
			resultCount: 0,
			resultCountDetail: 1,
			addLPNmodal: false,
			detailLPNmodal: false,
			isDisabled: false,
			LPNaction: '',
			useremail: '',
			warehouseid: 0,
			listLPNData: [],
			listLPNDetailsData: [],
			clientid: '',
			// pageno: 0,
			// pagecount: 0,
			totalPageDetail: 0,
			totalPage: 0,
			totalRows:0,
			totalRowsDetails:0,
			currentPage: 1,
			currentPage2: 1,
			pageLimit:5,
			lpnaction: '',
			//
			// pagenoDetail: 0,

			lpnid: '',
			status: '',
			lpntype: '',
			quantity: '',
			clientListData: [],
			searchFlag: false,
			isLoading: false,
			addclientid: '',

			showSelectClient: false,
			showSelectWarehouse: false,
			ClientErr: '',
			WarehouseErr: '',
			listWarehouseAll: [],
			listWarehouseAddLpn: [],
			client: '',
			warehouse: '',
			loginUserEmail: '',
			addWarehouseid: '',
			changelpnmodal: false,
			selectedLPNId: '',
			user_type: '',

		}
	},

	created: function() {},
	computed: {},

	mounted() {

		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.loginUserEmail = userdetail.email;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.loginUserEmail = userdetail.email;
				this.clientid = userdetail.clientid;
				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break;

		}

	},
	methods: {

		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseAll = JSON.parse(plaintextwarehouse);
		// 		if (this.listWarehouseAddLpn.length == 0) {
		// 			this.listWarehouseAddLpn = this.listWarehouseAll;
		// 		}
		// 	} else {

		// 	var userToken = window.localStorage.getItem('userToken')
		// 	var myStr = userToken.replace(/"/g, '');

		// 	this.input = ({
		// 		clientid: this.clientid,
		// 	});

		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 		.then(result => {
		// 			this.listWarehouseAll = result.data.data;
		// 			if (this.listWarehouseAddLpn.length == 0) {
		// 				this.listWarehouseAddLpn = result.data.data;
		// 			}
		// 		}, error => {
		// 			console.error(error)
		// 		})
		// 	}
		// },

		// getWarehouseListForAddLpn() {
		// 	var userToken = window.localStorage.getItem('userToken')
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.pageno = 0;

		// 	this.input = ({
		// 		clientid: this.addclientid,
		// 	});

		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 		.then(result => {
		// 			this.listWarehouseAddLpn = result.data.data;
		// 		}, error => {
		// 			console.error(error)
		// 		})
		// },

		closerlpnStatusModal() {
			this.changelpnmodal = false;
		},
		getLPNStatus(data) {
			this.selectedLPNId = data.lpnid;
			this.changelpnmodal = true;
		},

		//open new pop up for saving the rto
		addNewLPN() {

			this.LPNaction = 'add',
				this.addLPNmodal = true,
				this.$validator.reset();
			this.quantity = '';
			this.addclientid = '';
			this.addWarehouseid = '';
			$("#quantity").val('');
		},

		//to close add (new) form
		closeNewLPNModal() {
			this.addLPNmodal = false
		},

		closeNrefreshNewLPNModal() {
			this.addLPNmodal = false;
		},

		closeInwardDetailModal() {
			this.detailLPNmodal = false;
		},

		generateNewLPN() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var isValidFlag = false;
			var actualWarehouseId = 0;
			var actualClientid = 0;

			// Actions Based on User TYpe
			if (this.user_type == "system_user") {
				if (localStorage.getItem("selectedWarehouse") == "") {
					return false;
				} else if (localStorage.getItem("selectedClient") == "") {
					return false;
				} else {
					actualWarehouseId = localStorage.getItem("selectedWarehouse");
					actualClientid = localStorage.getItem("selectedClient")
					isValidFlag = true;
				}

			} else if (this.user_type == "warehouse_user") {
				if (this.addclientid == "") {
					return false;
				} else {
					actualWarehouseId = localStorage.getItem("selectedWarehouse");
					actualClientid = localStorage.getItem("selectedClient")
					isValidFlag = true;
				}

			} else {
				if (this.addWarehouseid == "") {
					return false;
				} else {
					actualWarehouseId = localStorage.getItem("selectedWarehouse");
					actualClientid = localStorage.getItem("selectedClient")
					isValidFlag = true;
				}
			}
			if (this.quantity == 0 || this.quantity < 0) {
				this.$alertify.error(this.$t('boxList.qtygreaterthan0'))
				return false;
			}

			if (isValidFlag == true && (this.quantity != '' || this.quantity != 0)) {

				this.input = ({

					email: this.loginUserEmail,
					clientid: actualClientid,
					warehouseid: actualWarehouseId,
					quantity: this.quantity
				})
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'generateLpn',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then((response) => {
						if (response.data.status == true) {
							this.$alertify.success(this.$t('lpnmaster.lpnCreated'))
							this.addLPNmodal = false
							//this.getLPNMasterList()
						} else {
							(response.data.status == false)
							this.$alertify.error(this.$t('lpnmaster.serverError'))
						}
					})
					.catch((httpException) => {
						console.error('exception is:::::::::', httpException)
					})
			} else {
				return false;
			}
		},
    getLPNMasterSearch(){
			this.currentPage = 1;
			this.getLPNMasterList();
		},
		getLPNMasterList() {
			if (localStorage.getItem("selectedWarehouse") == "undefined" || localStorage.getItem("selectedClient") == "undefined") {
				if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
					this.$alertify.error(this.$t('common.clientError'))
					return false;
				}

				if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
					this.$alertify.error(this.$t('common.warehouseError'))
					return false;
				}
			} else {
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				this.isLoading = true;

				this.resultCount = 0;
				this.input = ({
					offset: (this.currentPage - 1) * 5,
					limit: this.pageLimit,
					warehouseid: localStorage.getItem("selectedWarehouse"),
					lpnid: this.lpnid,
					status: this.status,
					clientid: localStorage.getItem("selectedClient")
				})
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getLPNMaster',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
						this.isLoading = false;
						this.totalRows=0
						this.listLPNData = []
						this.listLPNData = result.data.data
						this.totalRows = result.data.count
						this.resultCount = result.data.count
						if (this.totalRows > 0) {
							if (this.totalRows < this.pageLimit) {
								this.totalPage = 1
							} else {
								this.totalPage = Math.ceil(this.totalRows / this.pageLimit)
							}
						}

					}, error => {
						console.error(error)
					})
			}

		},

		getNewClientData() {
			this.lpnid = '';
			this.status = '';
			this.searchFlag = false;
			this.pageno = 0;
			this.pagecount = 0;
			this.resultCount = 0;
			this.totalRows=0;
			this.listLPNData = [];
			this.searchFlag = false;

			document.getElementById("lpnid").value = "";
			document.getElementById("status").value = "";

			if (localStorage.getItem("selectedClient") == "") {
				return false;
			} else {
				this.getLPNMasterList();
			}

		},
		//to get Client list
		// getClientList() {
		// 	this.resultCount = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.clientListData = JSON.parse(plaintextclient);
		// 	} else {
		// 	var userToken = window.localStorage.getItem('userToken')
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.resultCount = 0;
		// 	this.input = ({
		// 		warehouseid: this.warehouseid,
		// 	});
		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 		.then(result => {
		// 			this.clientListData = result.data.data;
		// 		}, error => {
		// 			console.error(error)
		// 		})
		// 	}
		// },

		saveCloseLpn() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({
				warehouseid: localStorage.getItem("selectedWarehouse"),
				clientid: localStorage.getItem("selectedClient"),
				lpnid: this.selectedLPNId
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'changeLpnStatus',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					var response = result.data.errorCode;
					if (response == 0) {
						this.$alertify.success(this.$t('lpnmaster.lpnClosed'));
						this.getLPNMasterList();
					}
				}, error => {
					console.error(error)
				})
		},

		resetForm() {
			this.lpnid = '';
			this.status = '';
			//this.getLPNMasterList();
		},

		resetSearchForm() {
			this.lpnid = '';
			this.status = '';
			this.listLPNData = [];
			this.totalRows=0;
			this.pagecount = 0;
			this.WarehouseErr = '';
			this.ClientErr = '';
			// if (this.user_type == 'warehouse_user') {
			// 	this.client = '';
			// 	this.clientid = ''
			// } else if (this.user_type == 'client_user') {
			// 	this.warehouse = '';
			// 	this.warehouseid = ''
			// } else {
			// 	this.client = '';
			// 	this.clientid = ''
			// 	this.warehouse = '';
			// 	this.warehouseid
			// }
		},

		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.listWarehouseData = []
		// 		this.getWarehouseList();
		// 		if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 			this.warehouse = this.warehouseid = '';
		// 		}
		// 	}
		// 	this.clientid = this.client;

		// 	if (this.clientid) {
		// 		this.resetForm();
		// 		if (this.warehouseid == '') {
		// 			this.getWarehouseList();
		// 		}
		// 	}
		// 	this.listLPNData = [];
		// 	this.totalRows=0;
		// 	this.pagecount = 0;
		// },

		// clientSelectedAdd() {
		// 	this.getWarehouseListForAddLpn();
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	if (this.warehouseid) {
		// 		if (this.clientid == '') {
		// 			this.getClientList();
		// 		}
		// 	}
		// 	this.totalRows=0;
		// 	this.listLPNData = [];
		// 	this.pagecount = 0;
		// },

		getLPNMasterListSearch() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if (localStorage.getItem("selectedClient") == '') {
				this.ClientErr = this.$t('rejectlistrto.clientIdError') ;
				return false;
			} else {
				this.searchFlag = true;
				this.input = ({
					offset: this.pageno,
					limit: this.pageLimit,
					warehouseid: localStorage.getItem("selectedWarehouse"),
					lpnid: this.lpnid,
					status: this.status,
					clientid: localStorage.getItem("selectedClient")
				})
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getLPNMaster',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
						this.listLPNData = result.data.data

						let totalRows = result.data.count
						this.resultCount = result.data.count
						if (totalRows < this.pageLimit) {
							this.pagecount = 1
						} else {
							this.pagecount = Math.ceil(totalRows / this.pageLimit)
						}
					}, error => {
						console.error(error)
					})
			}
		},

		viewLPNPDetailPopUp(data) {
			this.detailLPNmodal = true;
			this.totalPageDetail = 0;
			this.getLPNProductList(data);
		},

		getLPNProductList(data) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				offset: (this.currentPage - 1) * 5,
				limit: this.pageLimit,
				warehouseid: localStorage.getItem("selectedWarehouse"),
				lpnid: data.lpnid,
				clientid: localStorage.getItem("selectedClient")

			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getLPNProductDetail',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listLPNDetailsData = result.data.data
					 this.totalRowsDetails = result.data.count
					this.resultCountDetail = result.data.count
					// if (this.resultCountDetail > 0) {
					// 	if (totalRows < this.pageLimit) {
					// 		this.totalPageDetail = 1
					// 	} else {
					// 		this.totalPageDetail = Math.ceil(totalRows / this.pageLimit)
					// 	}
					// } else {
					// 	this.resultCountDetail = 0;
					// }
					// if (this.totalRowsDetails > 0) {
						if (this.totalRowsDetails < this.pageLimit) {
							this.totalPageDetail = 1
						} else {
							this.totalPageDetail = Math.ceil(this.totalRowsDetails / this.pageLimit)
						}
					// } else {
					// 	this.resultCountDetail = 0;
					// }

				}, error => {
					console.error(error)
				})
		},

		//to get pagination
		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * this.pageLimit;
		// 	this.getLPNMasterList()
		// },
		onPageChange(page) {
		  this.currentPage = page;
		  this.getLPNMasterList()
		},


		//to get pagination for LPN Details

		// getPaginationDataDetail(currentPage2) {
		// 	this.pagenoDetail = (currentPage2 - 1) * this.pageLimit;
		// 	this.getLPNProductList()
		// },
		getPaginationDataDetail(currentPage2) {
			this.currentPage2 = page;
			this.getLPNProductList()
		},
		//validate all form fields on onsubmit()
		onSubmit: function() {
			this.$validator.validateAll().then(() => {
				console.log('form is valid')
			}).catch(() => {
				console.log('errors exist')
			});
		},

	}
}



// WEBPACK FOOTER //
// ./src/views/components/sr/lpnmaster/lpnmaster.component.js